import React, { useEffect } from 'react';

// POPUP DIÁRIO DE NOVIDADES DO ESTÁDIO
// A decisão de mostrar/não mostrar NÃO está aqui — está em ./stadiumUpdate.js.
// Este ficheiro só desenha. Para mudar o texto das novidades, edita a lista abaixo:
// é o único sítio no projeto onde ela existe.

export const NOVIDADES_DO_ESTADIO = [
  'Câmaras mais rápidas a entrar em campo — menos ecrãs pretos.',
  'A revanche já não corta o vídeo: ficas em campo entre partidas.',
  'Nomes e janelas sempre certos, mesmo depois de várias revanches.',
];

export const TITULO_ATUALIZACAO = 'O ESTÁDIO FOI ATUALIZADO';

function PopupAtualizacaoEstadio({ aoFechar, titulo = TITULO_ATUALIZACAO, novidades = NOVIDADES_DO_ESTADIO }) {
  // Tecla ESC fecha o aviso (teclado no desktop; no telemóvel usa-se o botão).
  useEffect(() => {
    const aoPremirTecla = (evento) => {
      if (evento.key === 'Escape' && typeof aoFechar === 'function') aoFechar();
    };
    window.addEventListener('keydown', aoPremirTecla);
    return () => window.removeEventListener('keydown', aoPremirTecla);
  }, [aoFechar]);

  const fechar = () => { if (typeof aoFechar === 'function') aoFechar(); };

  return (
    <div
      onClick={fechar}
      role="dialog"
      aria-modal="true"
      aria-label={titulo}
      style={{
        position: 'fixed',
        inset: 0,
        // Acima de tudo o resto: o valor mais alto no projeto é 9999999 (JogoPK,
        // TorneiosPK, JogosLigaPK e Feed usam-no nas animações de presentes).
        zIndex: 10000000,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        boxSizing: 'border-box',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="notranslate"
        translate="no"
        style={{
          backgroundColor: '#111',
          border: '2px solid #39FF14',
          borderRadius: '20px',
          boxShadow: '0 0 25px rgba(57, 255, 20, 0.4)',
          padding: '25px 20px',
          width: '100%',
          maxWidth: '340px',
          maxHeight: '80vh',
          overflowY: 'auto',
          textAlign: 'center',
          boxSizing: 'border-box',
        }}
      >
        <div style={{ fontSize: '34px', lineHeight: 1, marginBottom: '10px' }}>🏟️⚽</div>

        <h2 style={{
          color: '#39FF14',
          fontSize: '17px',
          fontWeight: 900,
          letterSpacing: '1px',
          margin: '0 0 16px 0',
        }}>
          {titulo}
        </h2>

        <ul style={{
          listStyle: 'none',
          padding: 0,
          margin: '0 0 22px 0',
          textAlign: 'left',
        }}>
          {novidades.map((novidade, indice) => (
            <li
              key={indice}
              style={{
                color: '#ddd',
                fontSize: '13px',
                lineHeight: 1.45,
                marginBottom: '10px',
                paddingLeft: '18px',
                position: 'relative',
              }}
            >
              <span style={{ position: 'absolute', left: 0, color: '#39FF14' }}>▸</span>
              {novidade}
            </li>
          ))}
        </ul>

        <button
          onClick={fechar}
          style={{
            background: '#39FF14',
            color: '#000',
            border: 'none',
            borderRadius: '25px',
            padding: '13px 30px',
            fontWeight: 900,
            fontSize: '13px',
            letterSpacing: '0.5px',
            cursor: 'pointer',
            width: '100%',
            boxShadow: '0 0 12px rgba(57, 255, 20, 0.5)',
          }}
        >
          VAMOS A JOGO ⚽
        </button>
      </div>
    </div>
  );
}

export default PopupAtualizacaoEstadio;
